$(function(){
    if ($('#productListSort').length) {
        var curURL = window.location;
        var curParams = curURL.search.substring(1).split('&');
        var curParam;
        var paramSort = 'sort';
        var defaultSort = 'newest';
        var curSort;

        $('#productListSort').val(defaultSort);

        //Set current sort value if in querystring
        for (var i = 0; i < curParams.length; i++){
            curParam = curParams[i].split('=');

            if(curParam[0] == paramSort) {
                curSort = curParam[1];
                $('#productListSort').val(curParam[1]);
            }
        }

        $('#productListSort').change(function () {

            var newSort = $(this).val();

            if(curSort){
                newURL = curURL.search.replace(/(sort=)[^\&]+/, '$1' + newSort);
            } else {
                newURL = curURL  + '&' + paramSort + '=' + newSort;
            }

            window.location.href = newURL;
        })
    }

    if ($('#jvz-marketplace-review-iframe').length) {
        iFrameResize({ log: true }, '#jvz-marketplace-review-iframe');
    }

    if ($('#showAllMenuItems').length) {
        $('#showAllMenuItems').click(function(){
            $('.prod-list-side-menu > li').removeClass('d-none');
            $('#showAllMenuItems').hide();
        })
    }
});